import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { isAuthenticated } from '../services/api'
import { playCover, playReveal } from '../composables/pageTransition'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/projets',
    name: 'projects',
    component: () => import(/* webpackChunkName: "projects" */ '../views/ProjectsView.vue')
  },
  {
    path: '/hq',
    name: 'hq',
    component: () => import(/* webpackChunkName: "hq" */ '../views/HqView.vue')
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AdminLoginView.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AdminView.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    return { name: 'admin-login' }
  }
  if (from.name) await playCover()
  return true
})

router.afterEach(() => {
  playReveal()
})

export default router
